/**
 * @param {Object} props
 * @param {String} color - the colour for the icon
 * @param {String} width - the width for the icon
 * @param {String} height - the height for the icon
 * @param {String} className - classnames to appl to the icon
 * @returns an arrow
 */
const NaCheckIcon = ({
  color = '#000000',
  width = '17',
  height = '17',
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 17"
    width={width}
    className={className}
    height={height}>
    <g data-name="Icon ionic-ios-checkmark-circle-outline">
      <path
        d="m12.857 5.921-.719-.74a.155.155 0 0 0-.114-.049.148.148 0 0 0-.114.049l-4.986 5.022-1.815-1.814a.158.158 0 0 0-.229 0l-.727.727a.163.163 0 0 0 0 .233l2.288 2.288a.724.724 0 0 0 .478.233.758.758 0 0 0 .474-.225l5.464-5.492a.175.175 0 0 0 0-.232Z"
        data-name="Path 12388"
        fill={color}
      />
      <path
        d="M8.5 1.144a7.353 7.353 0 1 1-5.2 2.154 7.307 7.307 0 0 1 5.2-2.154M8.5 0A8.5 8.5 0 1 0 17 8.5 8.5 8.5 0 0 0 8.5 0Z"
        data-name="Path 12389"
        fill={color}
      />
    </g>
  </svg>
);
export default NaCheckIcon;
